/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyBill } from 'app/shared/model/pharmacy-bill.model';
import { IPharmacist } from 'app/shared/model/pharmacist.model';
import { IPackageSubscriber } from 'app/shared/model/package-subscriber.model';
import { IHospitalPayment } from 'app/shared/model/hospital-payment.model';
import { IInsuranceClaim } from 'app/shared/model/insurance-claim.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IPharmacyBillPayment {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  tmCursor?: number | null;
  timestampentry?: number | null;
  microSec?: number | null;
  lastupdated?: number | null;
  settledAtHospital?: boolean | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  forCredit?: boolean | null;
  voided?: boolean | null;
  voidedReason?: string | null;
  voidedDate?: number | null;
  pharmacyBill?: IPharmacyBill | null;
  collectedBy?: IPharmacist | null;
  subscriber?: IPackageSubscriber | null;
  hospitalPayment?: IHospitalPayment | null;
  claim?: IInsuranceClaim | null;
}

export const defaultValue: Readonly<IPharmacyBillPayment> = {
  active: false,
  settledAtHospital: false,
  forCredit: false,
  voided: false,
};
